import React, { useContext } from 'react'
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import { fetchSimulationVehicleDetailsIfNeeded } from '../actions/actionsApiSimulation'
import DetailsButton from '../components/results/DetailsButton'

export default function ContDetailsButton(props) {
  const dispatch = useContext(ReducerDispatchContext);
  const globalstate = useContext(ReducerContext);
  const configurationKey = props.configurationKey ? props.configurationKey : 'default';

  function onOpen(vehicle) {
    fetchSimulationVehicleDetailsIfNeeded(globalstate, dispatch, {vehicle:vehicle}, null, false, true);
  }

  return (
    <DetailsButton
      vehicleDetails={globalstate.responseSimulation.vehicleDetails}
      settings={globalstate.settings}
      text={props.text}
      configurationKey={configurationKey}
      detailOpenText={props.detailOpenText}
      vehicleDetailsIn={props.vehicleDetailsIn}
      vehicle={props.vehicle}
      detailLabel={props.detailLabel}
      showCtaText={props.showCtaText}
      href={props.href}
      onOpen={onOpen}
    />
  );
}
